/**
 * Якорные ссылки, которые «подцепляются»,
 * когда до них доскроллили
 */

let length;
let smController = new ScrollMagic.Controller({
    globalSceneOptions: {
        duration: '10000%'
    }
});


class FixedAnchor {
    constructor(el, index) {
        this.$container = $(el);
        this.index = index;
        this.HEIGHT = App.H.is('.page-employee') ? 30 : 42;
        this.MARGIN = App.H.is('.page-employee') ? 5 : 0;
        this.$link = this.$container.find('.js-fixed-anchor-link');

        this.init();
        this.bindClick();
    }



    init() {
        new ScrollMagic.Scene({
            triggerElement: this.$container[0],
            triggerHook: 'onEnter',
            /**
             * Фиксированные якоря располагаются друг над другом,
             * поэтому оффсет каждого сдвигаем на высоту якорей,
             * которые лежат под ним. Считаем в обратном порядке,
             * т.к первый лежит в самом верху, последний — низу
             */
            offset: (length - (this.index)) * this.HEIGHT + this.MARGIN
        })
        // .addIndicators()
        .addTo(smController)
        .on('enter', () => {
            this.$container.addClass('_fixed');
        })
        .on('leave', () => {
            this.$container.removeClass('_fixed');
        });

        /**
         * Добавляем переменную количества якорей,
         * чтобы использовать её в css
         */
        document.documentElement.style.setProperty('--anchorsLength', length);
    }



    bindClick() {
        this.$link.on('click', (e) => {
            e.preventDefault();

            let top = this.$container.offset().top - 70;

            /**
             * Для страницы сотрудника делаем поправку
             * из-за прилипающей шапки
             */
            if (App.H.is('.page-employee') && App.W.width() > 1139) {
                top = this.$container.offset().top - 190;
            }

            $('html, body').animate({
                scrollTop: top
            }, 500);
        });
    }
}


if (!App.mobile) {
    length = $('.js-fixed-anchor-container').length;

    $('.js-fixed-anchor-container').each(function(i) {
        new FixedAnchor(this, i);
    });
}



// WEBPACK FOOTER //
// ./_src/js/modules/FixedAnchor.js